import _ from 'lodash'
import { priceSortField, deliverySortField } from '../../features/table/sortSlice'
import { ASC_SORT_ORDER } from '../constants/sortOrders'
import { linemediaOriginalType, linemediaAnalogType } from '../constants/partGroupes'

const getTopParts = (parts, currency) => {
    const asc = ASC_SORT_ORDER.toLowerCase()

    // Exclude zero price parts
    parts = parts.filter((part) => part[priceSortField] > 0)

    const originals = parts.filter((part) => part.group.includes(linemediaOriginalType))
    const analogs = parts.filter((part) => part.group.includes(linemediaAnalogType))

    const getCheapestOriginal = () => {
        return _.first(_.orderBy(originals, [priceSortField, deliverySortField], [asc, asc]))
    }

    const getCheapestAnalog = () => {
        return _.first(_.orderBy(analogs, [priceSortField, deliverySortField], [asc, asc]))
    }

    const getFastest = () => {
        return _.first(
            _.orderBy(_.concat(originals, analogs), [deliverySortField, priceSortField], [asc, asc])
        )
    }

    return {
        cheapestOriginal: getCheapestOriginal(),
        cheapestAnalog: getCheapestAnalog(),
        fastest: getFastest()
    }
}

export default getTopParts
